
export class RiferimentoEsternoVO {
    id: string
    sistema: string
}